<div>
    <input [(ngModel)]="value"
        (ngModelChange)="onChange($event)" class="inputField"
        [disabled]="disabled">

    <span (click)="onDelete()" class="table__filter_icon"
        [ngClass]="{'icon-search': !value,'icon-shut':value}"></span>
</div>
